function Eagerly_Tools_Cookie( options ) {
	this.options = $.extend({
		debug: false,
		//root: '/includes/cookie',
		before: function(stat){}, //stat = open, close of submit
		after: function(stat){} //stat = open, close of submit
	}, options);

	this.first_loaded = false;
	this.youtube_loaded = false;
	this.fb_loaded = false;
	this.twitter_loaded = false;
	this.google_loaded = false;

	var _this = this;

	this.form = {
		checkbox: function() {
			$( '.cookie-checkbox-group input' ).change( function() {
				var $this = $( this ).parents( '.cookie-checkbox-group' );
				if ( $( this ).is( ':checked' ) ) {
					$this.addClass( 'checked' );
				} else {
					$this.removeClass( 'checked' );
				}
			});
		},
		init: function() {
			this.checkbox();
		},
	};

	this.cookie = {
		$container: false,
		$overlay: false,
		$btn: false,
		active: false,
		settings: false,
		open: function() {
			if ( _this.cookie.active == false ) {
				$.isFunction(options.before) && options.before.call( _this.cookie.$container, 'open' );
				this.active = true;
				this.$overlay.show();
				$('body').init('.cookie-svg-icon', $('.cookie-fb-content'));
				//set max height scroller:
				var h = $( window ).height() - $( '.cookie-fb-top' ).outerHeight( true ) - $( '.cookie-fb-bottom' ).outerHeight( true );
				$( '.cookie-fb-scroller' ).css( { 'max-height': h } );
				_this.cookie.$container.removeClass('hide-mob');
				setTimeout(function() {
					if ( 'undefined' != typeof $.fn.icons ) {
						$('body').icons.init( '.svg-icon' );
					}
					_this.cookie.$overlay.addClass('active');
					_this.cookie.$container.addClass('active');
				}, 10);
			}
		},
		close: function() {
			if ( _this.cookie.active == true ) {
				$.isFunction(options.before) && options.before.call(_this.cookie.$container, 'close');
				_this.cookie.active = false;
				setTimeout(function() {
					_this.cookie.$overlay.removeClass( 'active' );
					_this.cookie.$container.removeClass( 'active' );
					setTimeout(function() {
						//TODO: dit moet nog even anders
						_this.cookie.$overlay.hide();
						_this.cookie.$container.addClass('hide-mob');
						$.isFunction(options.after) && options.after.call(_this.cookie.$container, 'close');
					}, 500);
				}, 10);
				_this.cookie.save();
			}
		},
		openSub: function( $this ) {
			if ( _this.cookie.active == true ) {
				var h = $this.next( '.cookie-item-content' ).height();
				var $item = $this.parents('.cookie-checkbox-group');
				if ($item.hasClass( 'active' )) {
					$item.removeClass( 'active' ).css( { 'height': 60 } );
				} else {
					$item.addClass( 'active' ).css( { 'height': 60 + h } ).siblings( '.cookie-checkbox-group' ).removeClass( 'active' ).css( { 'height': 60 } );
				}
			}
		},
		clicks: function() {
			this.setHTMLElements();
			_this.cookie.$replacementBtn.unbind('click').on('click', function( e ) {
				e.preventDefault();
				if (_this.cookie.active == false) {
					_this.cookie.open();
				} else {
					_this.cookie.close();
				}
			});
			_this.cookie.$btn.unbind('click').on('click', function( e ) {
				e.preventDefault();
				if (_this.cookie.active == false) {
					_this.cookie.open();
				} else {
					_this.cookie.close();
				}
			});
			_this.cookie.$container.find('.btn-close,.btn-ok' ).unbind('click').on( 'click', function( e ) {
				e.preventDefault();
				if (_this.cookie.active == true) {
					_this.cookie.close();
				}
			} );
			_this.cookie.$overlay.unbind('click').on( 'click', function( e ) {
				_this.cookie.close();
			} );
			$( '.open-cookie-item' ).unbind('click').on('click', function( e ) {
				e.preventDefault();
				_this.cookie.openSub( $(this) );
			} );
			$( '.cookie-fb-bottom .cookie-checkbox-group input' ).unbind('change').change( function() {
				if ( $(this).is( ':checked' ) ) {
					$( '.cookie-fb-scroller .cookie-checkbox-group:not(.disabled)' ).each( function() {
						$( this ).addClass( 'checked' ).find( 'input' ).prop( 'checked', true );
					} );
				} else {
					$( '.cookie-fb-scroller .cookie-checkbox-group:not(.disabled)' ).each( function() {
						$( this ).removeClass( 'checked' ).find( 'input' ).prop( 'checked', false );
					} );
				}
			} );
			$( '.cookie-fb-scroller .cookie-checkbox-group input' ).unbind('change').change( function() {
				var active = true;
				$('.cookie-fb-scroller .cookie-checkbox-group').each(function() {
					if (!$(this).hasClass('checked')) {
						active = false;
					}
				});
				if (active == true) {
					$( '.cookie-fb-bottom .cookie-checkbox-group input' ).prop( 'checked', false );
				} else {
					$( '.cookie-fb-bottom .cookie-checkbox-group input' ).prop( 'checked', true );
				}
			} );
		},
		init: function() {
			this.setHTMLElements();

			_this.cookie.settings = this.get('cookie_settings');
			_this.cookie.updateDOM( '' );
			_this.cookie.doGTMEvents('');

			_this.cookie.clicks();
			if (_this.cookie.settings === false) {
				_this.first_loaded = true;
				var h = _this.cookie.$container.find( '.cookie-fb-content' ).outerHeight( true ) - 130;
				_this.cookie.$container.addClass('first');
				_this.cookie.$btn.click();
				// if mobile:
				if ( $(window).width() <= 767 ) {
					_this.cookie.$container.find( '.cookie-fb-content' ).css( { '-webkit-transform': 'translate3d(0, '+h+'px, 0)', '-moz-transform': 'translate3d(0, '+h+'px, 0)', 'transform': 'translate3d(0, '+h+'px, 0)' } );
				}
				$('#eagerly-tools-cookie .js-open-cookie-settings').click(function(e) {
					e.preventDefault();
					if ( $(window).width() <= 767 ) {
						_this.cookie.$container.find('.cookie-fb-content').css({ '-webkit-transform': 'translate3d(0, 0, 0)', '-moz-transform': 'translate3d(0, 0, 0)', 'transform': 'translate3d(0, 0, 0)', 'transition': 'opacity 0.5s ease, transform 0.5s ease' } );
					}
					_this.cookie.$overlay.addClass('active');
					$( '#eagerly-tools-cookie .cookie-fb-top .js-open-cookie-settings' ).unbind( 'click' );
					setTimeout( function() {
						$( '#eagerly-tools-cookie .js-open-cookie-settings' ).slideUp( function() {
							_this.cookie.$container.removeClass('first');
						});
					}, 500);
				});
			} else {
				_this.cookie.$container.removeClass('first').removeAttr('style');
			}
		},
		save: function() {
			var new_settings = [ 'default' ],
				prev_settings = _this.cookie.settings;
			_this.cookie.$container.find('.cookie-fb-scroller input:not(:disabled):checked').each(function(){
				new_settings.push( $(this).val() );
			});
			_this.cookie.set('cookie_settings', new_settings, true );
			_this.cookie.settings = new_settings.join(',');
			// todo: update front-end
			_this.cookie.updateDOM( prev_settings );
			_this.cookie.doGTMEvents(prev_settings);
		},
		get: function(name) {
			var value = "; " + document.cookie;
			var parts = value.split("; " + name + "=");
			if ( parts.length == 2 ) {
				return parts.pop().split(";").shift();
			}
			return false;
		},
		set : function(name, value, time) {
			var expires = "";
			if (time != 'session' && time != false) {
				var date = new Date();
				date.setTime(date.getTime()+(30*24*60*60*1000));
				expires = "; expires="+date.toGMTString();
			}
			document.cookie = name+'='+value+expires+'; path=/'
		},
		updateDOM : function(prev_settings) {

			if ( false !== _this.cookie.settings ) {
				var settings = _this.cookie.settings;

				if ( '' != prev_settings && prev_settings == settings ) {
					_this.debug('no change!');

					return false;
				}

				if ( settings.indexOf(',') > -1 ) {
					settings = settings.split(',');
				} else {
					settings = [ settings ];
				}

				if ( '' != prev_settings ) {
					if ( prev_settings.indexOf(',') > -1 ) {
						prev_settings = prev_settings.split(',');
					} else {
						prev_settings = [ prev_settings ];
					}
				} else {
					prev_settings = settings;
				}

				if ( settings.length < prev_settings.length || ( settings.length > prev_settings.length && 1 == cookieData.forceReload ) ) {
					// NOTE: reload page to unload API's
					window.location.reload();
				} else if ( settings.length == 1 ) {
					_this.debug( settings );

					_this.disableYouTube();
					_this.enableEmbeds(['functional']);
				} else {
					// NOTE: load specific API's
					for ( var key in settings ) {
						_this.debug( settings[ key ] );

						switch ( settings[ key ] ) {
							case 'tracking':
								_this.enableYouTube();
								_this.enableShare();
								_this.enableEmbeds();
								break;
							case 'settings':
							case 'statistics':
								_this.enableEmbeds(['functional', 'vimeo']);
							case 'other':
								// not yet
								break;
						}
					}
				}
			}
		},
		doGTMEvents: function( prev_settings ) {
			if ( false !== _this.cookie.settings ) {
				var settings = _this.cookie.settings;

				if ( '' != prev_settings && prev_settings == settings ) {
					_this.debug( 'GTM: no change!' );
					return false;
				}

				settings = _this.settingsStringToArray( settings );

				window.dataLayer = window.dataLayer || [];

				for ( var key in settings ) {
					_this.debug( 'GTM push event: "eagerly_cookie_' + settings[ key ] + '"' );
					window.dataLayer.push({
						'event': 'eagerly_cookie_' + settings[ key ]
					});
				}
			}
		},
		setHTMLElements: function() {
			this.$container = $( '#eagerly-tools-cookie' );
			this.$overlay = $( '#eagerly-tools-cookie-overlay' );
			this.$btn = $( '.js-cookie-btn' );
			this.$replacementBtn = $( '.js-cookie-replacement-btn' );
		},
	};

	this.debug = function( message ) {
		if ( this.options.debug ) {
			console.log( message );
		}
		return;
	};

	this.settingsStringToArray = function( string ) {
		if ( string.indexOf(',') > -1 ) {
			array = string.split(',');
		} else {
			array = [ string ];
		}
		return array;
	};

	this.init();
}

Eagerly_Tools_Cookie.prototype.close = function() {
	this.cookie.open();
}

Eagerly_Tools_Cookie.prototype.open = function() {
	this.cookie.close();
}

Eagerly_Tools_Cookie.prototype.enableYouTube = function() {
	this.debug('enable YT');
	var check_yt;
	check_yt = setInterval( function(){
		if ( 'undefined' != typeof YTplayer ) {
			clearInterval( check_yt );
			this.youtube_loaded = true;
			this.debug('init YT');

			YTplayer.init = false;
			$.fn.youtube();
		}
	}, 100 );
}

Eagerly_Tools_Cookie.prototype.enableEmbeds = function( exceptions ) {
	if ( 'undefined' == typeof exceptions ) {
		var exceptions = [];
	}
	var _this = this;
	if ( $('body .eagerly-tools-cookie-iframe.eagerly-tools-cookie-blocked').length > 0 ) {
		$('body .eagerly-tools-cookie-iframe.eagerly-tools-cookie-blocked').each(function(){
			var youtube_id = false;
			var embed_src = $(this).data('embed_src');
			if ( exceptions.indexOf('vimeo') > -1 && ! vimeo_parser( embed_src ) ) {
				return;
			} else if ( exceptions.indexOf('functional') > -1 && 'undefined' != typeof cookieData.embedExceptions ) {
				var $check = false;
				for ( var x in cookieData.embedExceptions ) {
					if ( embed_src.indexOf( cookieData.embedExceptions[ x ] ) > -1 ) {
						var $check = true;
					}
				}
				if ( ! $check ) {
					return;
				}
			} else {
				youtube_id = _this.youtube_parser( embed_src );
			}
			if ( youtube_id ) {
				_this.debug( 'loading YT: ' + youtube_id );
				$(this).replaceWith('<iframe src="' + embed_src + '" />');
			} else {
				_this.debug('not youtube');
				var embed_width = '', embed_height = '';
				if ( 'undefined' != typeof $(this).data('embed_width') ) {
					embed_width = ' width="' + $(this).data('embed_width') + '"';
				}
				if ( 'undefined' != typeof $(this).data('embed_height') ) {
					embed_width = ' height="' + $(this).data('embed_height') + '"';
				}
				$(this).replaceWith('<iframe src="' + embed_src + '"' + embed_width + embed_height + ' />');
			}
		});
	}
	if ( $('body .eagerly-tools-cookie-embed.eagerly-tools-cookie-blocked').length > 0 ) {
		$('body .eagerly-tools-cookie-embed.eagerly-tools-cookie-blocked').each( function() {
			if ( exceptions.indexOf('functional') > -1 && 'undefined' != typeof cookieData.embedExceptions ) {
				var $check = false;
				for ( var x in cookieData.embedExceptions ) {
					if ( embed_src.indexOf( cookieData.embedExceptions[ x ] ) > -1 ) {
						var $check = true;
					}
				}
				if ( ! $check ) {
					return;
				}
			}
			$(this).replaceWith( $(this).data('embed') );
		});
	}
}

Eagerly_Tools_Cookie.prototype.disableYouTube = function() {
	this.debug('disable YT');

	var check_yt;
	check_yt = setInterval( function(){
		if ( 'undefined' != typeof YTplayer ) {
			clearInterval( check_yt );
			youtube_loaded = false;
			YTplayer.$this.hero = null;
			YTplayer.init = true;
		}
	}, 100 );

	this.debug( cookieData.yt.videoPlayerID );

	if ( $( cookieData.yt.videoPlayerID ).length > 0 ) {
		$( cookieData.yt.videoPlayerID ).html('<div class="eagerly-tools-player eagerly-tools-cookie-blocked"><span>' + cookieData.yt.videoPlayerWarning + '</span></div>');
		if ( this.first_loaded ) {
			this.cookie.clicks();
		}
	}
}

Eagerly_Tools_Cookie.prototype.youtube_parser = function(url){
	var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
  var match = url.match(regExp);
  return (match&&match[7].length==11)? match[7] : false;
}

Eagerly_Tools_Cookie.prototype.vimeo_parser = function(url){
	var regExp = /(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^\/]*)\/videos\/|album\/(?:\d+)\/video\/|video\/|)(\d+)(?:[a-zA-Z0-9_\-]+)?/i;
  var match = url.match(regExp);
  return (match&&match[1].length==9)? match[1] : false;;
}

Eagerly_Tools_Cookie.prototype.enableFacebook = function() {
	this.debug('enable FB');

	(function(d, s, id) {
  	 var js, fjs = d.getElementsByTagName(s)[0];
  	 if (d.getElementById(id)) return;
  	 js = d.createElement(s); js.id = id;
  	 js.src = "//connect.facebook.net/nl_NL/sdk.js#xfbml=1&version=v2.5";
  	 fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));
}

Eagerly_Tools_Cookie.prototype.enableTwitter = function() {
	this.debug('enable Twitter');

	(function(d, s, id) {
		var js, fjs = d.getElementsByTagName(s)[0];
		if (d.getElementById(id)) return;
		js = d.createElement(s); js.id = id;
		js.src = "//platform.twitter.com/widgets.js";
		js.charset = "utf-8";
		js.async = true;
		fjs.parentNode.insertBefore(js, fjs);
	}(document, 'script', 'twitter-wjs'));
}

Eagerly_Tools_Cookie.prototype.enableLinkedin = function() {
	this.debug('enable LinkedIn');

	(function(d, s, id) {
  	 var js, fjs = d.getElementsByTagName(s)[0];
  	 if (d.getElementById(id)) return;
  	 js = d.createElement(s); js.id = id;
  	 js.src = "//platform.linkedin.com/in.js";
  	 fjs.parentNode.insertBefore(js, fjs);
	 }(document, 'script', 'linkedin-widget'));
	// lang: <?php echo $active_lang[ 'locale' ] ?>
}

Eagerly_Tools_Cookie.prototype.enableShare = function() {
	var _this = this;
	var ajax_data = { 'action' : cookieData.ajaxAction.shares, 'post_id' : cookieData.currentID };

	this.debug('enable share');

	$.ajax({
		url: cookieData.ajaxURL,
		data: ajax_data,
		method: 'POST',
		dataType: 'json'
	}).done(function(data) {
		if ( 'undefined' != typeof data.html ) {
			$( cookieData.shareContainerID ).html( data.html );
			$('.share .shares').html( data.html );
			$('.share').show();
			if ( 'undefined' != typeof $.fn.icons ) {
				$('body').icons.init( '.svg-icon', $('.share'));
			}
			_this.enableFacebook();
			_this.enableTwitter();
			_this.enableLinkedin();
		}
	});
}

Eagerly_Tools_Cookie.prototype.init = function() {
	var _this = this;
	var ajax_data = { 'action' : cookieData.ajaxAction.cookie_settings };

	$.ajax({
		url: cookieData.ajaxURL,
		data: ajax_data,
		method: 'POST',
		dataType: 'json'
	}).done(function(data) {
		if ( 'undefined' != typeof data.html ) {
			if ( ! _this.cookie.active ) {
				$('body').append( data.html );
				_this.cookie.init();
				_this.form.init();
				setTimeout( function() {
					_this.cookie.$btn.css( { 'opacity': 1 } );
				}, 2000 );
			}
		}
	});
}

$(function(){
	eagerly_cookie = new Eagerly_Tools_Cookie({
		debug: false,
		//root : '/includes/cookie',
		before : function(stat) {
			//console.log(stat);
			// voor bijvoorbeeld lock scroll
		},
		after : function(stat) {
			//console.log(stat);
			// voor bijvoorbeeld unlock scroll
		}
	});
});
